import React, { Fragment, useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useQuery, useMutation } from 'react-apollo-hooks';
import gql from 'graphql-tag';

// Components
import MainNavigation from '../components/MainNavigation';
import Logout from '../components/Logout';
import PrivateRoute from '../utils/PrivateRoute';

// Routes
import Login from './login';
import Home from './home';
import Chats from './chats';
import Teach from './teach';
import QaRoute from './qa';
import Tags from './tags';
import Acts from './acts';
import Act from './acts/Act';

const Header = () => (
  <header className="main-header">
    <Switch>
      <Route exact path="/" render={() => <Fragment>Etusivu</Fragment>} />
      <Route path="/chats" render={() => <Fragment>Logit</Fragment>} />
      <Route path="/teach" render={() => <Fragment>Opetus</Fragment>} />
      <Route path="/qa" render={() => <Fragment>Q&A</Fragment>} />
      <Route path="/tags" render={() => <Fragment>Tagit</Fragment>} />
      <Route path="/acts" render={() => <Fragment>Speech Acts</Fragment>} />
    </Switch>
  </header>
);

const Footer = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return <footer>Copyright &copy; {currentYear} Smartifik Oy</footer>;
};

const Root = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  return (
    <Fragment>
      <div className="app">
        <Switch>
          <Route exact path="/login" render={props => <Login {...props} />} />
          <PrivateRoute path="/" component={App} />
        </Switch>
      </div>
      <Footer />
    </Fragment>
  );
};

const App = () => (
  <Fragment>
    <aside className="aside">
      <header className="aside-header">Smartti</header>
      <MainNavigation />
      <Logout />
    </aside>
    <main>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/chats" component={Chats} />
        <Route path="/teach" component={Teach} />
        <Route path="/qa" component={QaRoute} />
        <Route path="/tags" component={Tags} />
        <Route path="/acts/:name" component={Act} />
        <Route path="/acts" component={Acts} />
        <Redirect to="/" />
      </Switch>
    </main>
  </Fragment>
);

export default Root;
